import GeneralHelper from '../../00_utilities/helpers/GeneralHelper';
import BreakpointHelper from '../../00_utilities/helpers/BreakpointHelper';

class NavigationSearch {
    constructor(elem) {
        this.elem = elem;
        this.triggerInput = document.getElementById('search-trigger');
        this.boundBodyClickListener = this.bodyClickListener.bind(this);
        this.breakpoints = {
            'screen-md': 992,
        };
    }

    init() {
        let aboveBreakpoint = BreakpointHelper.aboveBreakpoint(this.breakpoints['screen-md']);

        this.setPadding(aboveBreakpoint);
        this.focusInputOnOpen();
        this.closeSearchOnClickOutside();
        this.focusTriggerOnFocusOut();

        window.addEventListener('resize', GeneralHelper.throttle(() => {
            const breakpointInfo = BreakpointHelper.breakpointCrossed(this.breakpoints['screen-md'], aboveBreakpoint);
            aboveBreakpoint = breakpointInfo.aboveBreakpoint;
            const { breakpointCrossed } = breakpointInfo;

            if (breakpointCrossed) {
                this.setPadding(aboveBreakpoint);
            }
        }, 200));
    }

    setPadding(aboveBreakpoint) {
        const searchWrapper = this.elem.querySelector('.navigation-search__wrapper');

        if (aboveBreakpoint) {
            const logoWrapperWidth = document.querySelector('.page-header__logo-wrapper').offsetWidth;
            searchWrapper.style.paddingLeft = `calc(${logoWrapperWidth}px + 1.5em)`;

            return;
        }
        searchWrapper.style.paddingLeft = 0;
    }

    focusInputOnOpen() {
        this.triggerInput.addEventListener('change', (event) => {
            const { currentTarget } = event;

            if (currentTarget.checked) {
                const searchInput = this.elem.querySelector('.navigation-search__input');
                searchInput.focus();
            }
        });
    }

    closeSearchOnClickOutside() {
        this.triggerInput.addEventListener('change', () => {
            // requestAnimationFrame is necessary for IE11. Without this, it would
            // run the eventhandler immediately for the click made on the checkbox
            window.requestAnimationFrame(() => {
                if (this.triggerInput.checked) {
                    document.body.addEventListener('click', this.boundBodyClickListener);
                } else {
                    document.body.removeEventListener('click', this.boundBodyClickListener);
                }
            });
        });
    }

    bodyClickListener(event) {
        const isClickInside = this.elem.querySelector('.navigation-search__form').contains(event.target);
        const isClickOnTrigger = document.querySelector('.navigation__search-trigger').contains(event.target);

        if (!isClickInside && !isClickOnTrigger) {
            this.closeSearchForm();
        }
    }

    closeSearchForm() {
        this.triggerInput.checked = false;

        // IE11 compatibility
        let event;
        if (typeof (Event) !== 'function') {
            event = document.createEvent('Event');
            event.initEvent('change', true, true);
        } else {
            event = new Event('change');
        }
        // end IE11 compatibility

        this.triggerInput.dispatchEvent(event);
    }

    focusTriggerOnFocusOut() {
        this.elem.addEventListener('keydown', (event) => {
            const { keyCode } = event;
            if (keyCode === 9) {
                if (document.activeElement.classList.contains('navigation-search__submit')) {
                    this.closeSearchForm();
                }
            }
        });
    }
}

export default NavigationSearch;
